export enum FlowOfFundsSubTab {
    OverallDealStructure = 1,
    ThirdPartyPayoffs = 2,
    VetValueFees = 3,
    LegalFees = 4,
    WireTransferSummary = 5,
}
